import React, { useEffect } from "react";
import { Box, Button, Drawer, FormControlLabel, Radio, RadioGroup, TextField, Typography } from "@material-ui/core";
import { useState } from "react";
import { useStyles } from "./styles";
import { Header } from "../../components/Header";
import I18n from "../../localization";
import moment from 'moment-timezone';
import Icon from "../../utils/icons";
import ToastMessage from "../../components/ToastMessage";
import { onFocusTextFieldFunc, validateName } from "../../utils/utility";
import { PAGES, SITE_VALIDATE_CODES, STATUS } from "../../utils/constant";
import HCServices from "../../services/hcServices";
import { allCountries } from "../../launchCountrys";
import { PopUp } from "../../components";
import ProvisionStepper from "../AirDeviceProvision/provisionStepper";

const SiteDetails = (props) => {
  const { handleClick, isDarkMode, siteId, setCreateNewSite } = props
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [reqObj, setReqObj] = useState({
    siteName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    timezone: moment.tz(moment.tz.guess())._z.name,
    hasManuallyEntered: false
  });
  const [errorMessageSiteName, setErrorMessageSiteName] = useState({ status: 'noerr', msg: ''})
  const [errorMessaeaddress1, setErrorMessageaddress1] = useState(false);
  const [errorMessaecity, setErrorMessagecity] = useState(false);
  const [errorMessaestate, setErrorMessagestate] = useState(false);
  const [errorMessaezip, setErrorMessagezip] = useState(false);
  const [errorMessagecountry, setErrorMessagecountry] = useState(false);
  const [errorMessagezipFormate, setErrorMessagezipFormate] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [countryDrawerOpen, setCountryDrawerOpen] = useState(false)
  const [stateDrawerOpen, setStateDrawerOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [isApiFailed, setIsApiFailed] = useState(false);
  const [countryApiData, setCountryApiData] = useState(allCountries)
  const [stateApiData, setStateApiData] = useState({})
  const [hasState, setHasState] = useState(true);
  const [showSiteValidatePopup, setShowSiteValidatePopup] = useState(false)
  const [showToast, setShowToast] = useState({ status: false, type: 'success', message: '' })
  const [showLoader, setShowLoader] = useState(false)
  const userLocale = localStorage.getItem('userLocale')

  const getCountryData = async (locale) => {
    setLoading(true)
    let dataArray = [];
    const codeSet = new Set(); // Track unique country codes
    const resData = await HCServices.getCountryDetails()
    if (resData.status === STATUS.SUCCESS) {
      const supportedCountries = resData.data;
      const supportedCountryCodes = supportedCountries.map(country => country.code);
      const resCountryOptions = await HCServices.getCountryOptions(locale);
      if (resCountryOptions.status === STATUS.SUCCESS) {
        const countryOptions = resCountryOptions.data
        supportedCountries.forEach(country => {
          if (codeSet.has(country.code)) return; // Skip if already added
          codeSet.add(country.code);

          const matchedOption = countryOptions?.find(
            option => supportedCountryCodes.includes(option.code) && option.code === country.code
          );
          dataArray.push({
            ...country,
            name: matchedOption ? matchedOption.name : country.name
          })
        })
        dataArray.sort((a, b) => a.name > b.name ? 1 : -1)
        setCountryApiData(dataArray)
        setIsApiFailed(false)
      }
    }
    else {
      setIsApiFailed(true)
    }
    setLoading(false)
  }

  useEffect(() => {
    const siteData = JSON.parse(localStorage.getItem('siteAddressDetails'));
    if (siteData) {
      setReqObj(siteData);
      isZipCode(siteData.zip, siteData.country);
    }
    getCountryData(userLocale)
  }, []);

  useEffect(() => {
    isValidSiteData(reqObj);
  }, [reqObj, hasState]);

  useEffect(() => {
    if (reqObj.country) {
      if (reqObj.country === "FR") {
        setHasState(false)
      } else {
        getListOfStateName(reqObj.country);
      }
    }
  }, [reqObj.country]);

  const getStateName = (stateList, state_code) => {
    const matchedState = stateList?.find(state => state[0] === state_code);
    return matchedState ? matchedState[0] : null;
  };

  const getStateFromStateCode = (stateList, state_code) => {
    const matchedState = stateList?.find(state => state[1] === state_code);
    return matchedState ? matchedState[0] : null;
  };

  const handleStateConfirmBtn = () => {
    if (selectedState) {
      setReqObj({ ...reqObj, state: selectedState, zip: reqObj.hasManuallyEntered ? reqObj.zip : '', city: reqObj.hasManuallyEntered ? reqObj.city : '' });
      setSelectedState(selectedState)
      setStateDrawerOpen(false);
    }
  }

  const getListOfStateName = async (selectedCountryCode) => {
    setLoading(true)
    setHasState(true)
    const data = await HCServices.getStatesForCountry(selectedCountryCode, userLocale)
    if (data.status === STATUS.SUCCESS) {
      data.country_states.sort((a, b) => a[0] > b[0] ? 1 : -1);
      setStateApiData(data)
      if (!data.country_states || data.country_states.length === 0) {
        setHasState(false)
        setReqObj({ ...reqObj, state: '' })
      }
      setIsApiFailed(false)
    } else {
      setIsApiFailed(true)
    }
    setLoading(false)
  }

  const allCountryCodes = countryApiData.map(country => [country.code]).flat()

  const getCountryName = (countryList, countries) => {
    return (countryList.find(country => country.code === countries))?.name
  }

  const isValidSiteData = (data) => {
    const errorMapping = {
      siteName: data.siteName === "" ? 'error' : 'noerr',
      address1: data.address1 === "" ? 'error' : 'noerr',
      city: data.city === "" ? 'error' : 'noerr',
      state: hasState && data.state === "" ? 'error' : 'noerr',
      zip: data.zip === "" ? 'error' : 'noerr',
      country: data.country !== "" && allCountryCodes.includes(data.country) ? 'noerr' : 'error',
    };

    // Removed individual field setError as this function is called on initial load 
    // and throwing errors for empty fields when page loads

    return Object.values(errorMapping).every(err => err === 'noerr');
  };

  const addSiteDevice = async () => {
    if (isValidSiteData(reqObj)) {
      if (reqObj && reqObj.address2 === "") {
        // Optional field: if 'address2' is empty, remove it from 'reqObj'
        delete reqObj.address2;
      }
      if (reqObj && reqObj.zip) {
        reqObj.zip = reqObj.zip.toUpperCase();
      }
      validateWithApi()
    } else {
      setShowSiteValidatePopup(true);
    }
  };

  const isZipCode = (str, countryCode) => {
    const country = allCountries.find((elem) => elem.code === countryCode);
    let zipPattern = country ? country.zipPattern : null
    setErrorMessagezipFormate(zipPattern ? (zipPattern.test(str) ? 'noerr' : 'error') : 'noerr');
  };

  const onTextChange = (name, value) => {
    if (name === "siteName") {
      const status = validateName(value)
      status === true ? setErrorMessageSiteName({status: 'noerr', msg: ''}) : setErrorMessageSiteName({status: 'error', msg: status})
    } else if (name === "streetAddress1") {
      setErrorMessageaddress1(value.trim() !== "" ? 'noerr' : 'error');
    } else if (name === "cityName") {
      setErrorMessagecity(value.trim() !== "" ? 'noerr' : 'error');
      if (value.trim() !== "") {
        setReqObj({ ...reqObj, city: value, hasManuallyEntered: true });
      }
    } else if (name === "stateName") {
      setErrorMessagestate(value.trim() !== "" ? 'noerr' : 'error');
    } else if (name === "zipCode") {
      setErrorMessagezip(value.trim() !== "" ? 'noerr' : 'error');
      if (value.trim() !== "") {
        setReqObj({ ...reqObj, zip: value, hasManuallyEntered: true });
      }
    }
  }

  const searchApi = async (address) => {
    const updatedReqObj = { ...reqObj, address1: address };
    setReqObj(updatedReqObj);
    const obj = {
      input: address,
      ...(reqObj?.country ? { country: reqObj.country } : {}),
    };
    const search = await HCServices.addressSearchApi(obj);
    const prediction = search?.prediction || [];
    setLocationData(prediction);
  };

  const searchApiwithPlace = async (placeid) => {
    let obj = {
      placeid: placeid
    }
    const search = await HCServices.addressDetailsApi(obj);
    getfullAddress(search)

  }

  const getfullAddress = (jsonObj) => {
    let postalCode = "";
    let city = "";
    let country = "";
    let state = "";
    let countryCode = "";
    let addressComponents = jsonObj.address_components
    let streetAddress = jsonObj.streetAdr
    let streetAddress2 = jsonObj.streetAdr2
    let postalCodeData = addressComponents.filter((data) => data.types[0] === 'postal_code');
    if (postalCodeData && postalCodeData.length !== 0) {
      postalCode = postalCodeData[0].long_name
    }
    let countryData = addressComponents.filter((data) => data.types[0] === 'country');
    if (countryData && countryData.length !== 0) {
      countryCode = allCountryCodes.includes(countryData[0].short_name) ? countryData[0].short_name : ""
      country = countryCode ? countryData[0].long_name : ""
    }
    let stateData = (reqObj.country || countryCode) !== "IT" ? addressComponents.filter((data) => data.types[0] === 'administrative_area_level_1') : addressComponents.filter((data) => data.types[0] === 'administrative_area_level_2');
    if (stateData && stateData.length !== 0) {
      state = stateData[0].short_name
    }
    let cityData = addressComponents.filter((data) => data.types[0] === 'locality');
    if (cityData && cityData.length !== 0) {
      city = cityData[0].long_name
    } else if (addressComponents.filter((data) => data.types[0] === 'postal_town')?.length !== 0) {
      city = addressComponents.filter((data) => data.types[0] === 'postal_town')[0].long_name
    } else if (addressComponents.filter((data) => data.types[0] === 'sublocality_level_1')?.length !== 0) {
      city = addressComponents.filter((data) => data.types[0] === 'sublocality_level_1')[0].long_name
    } else {
      city = "";
    }


    if (city !== "") {
      setErrorMessagecity('noerr')

    }
    if (state !== "") {
      setErrorMessagestate('noerr')

    }
    if (postalCode !== "") {
      setErrorMessagezip('noerr')
      isZipCode(postalCode, countryCode)
    }
    if (countryCode !== "") {
      setErrorMessagecountry('noerr')
    }
    setReqObj({ ...reqObj, address1: streetAddress, address2: streetAddress2, city: city, state: state, zip: postalCode, country: countryCode, hasManuallyEntered: false })
  }

  const validateWithApi = async () => {
    setShowLoader(true)
    const obj = {
      "address1": reqObj.address1.trim(),
      "city": reqObj.city.trim(),
      "state": reqObj.state,
      "zip": reqObj.zip.trim(),
      "country": reqObj.country
    }
    if (!hasState) {
      delete obj.state
    }
    const isExistingUser = false
    const validatedSiteDetails = await HCServices.postSiteDetailsValidate(obj, isExistingUser)
    if (validatedSiteDetails?.status === STATUS.SUCCESS) {
      setShowSiteValidatePopup(false)
      let updatedObj = {
        ...reqObj,
        latitude: validatedSiteDetails?.siteAddress?.latitude,
        longitude: validatedSiteDetails?.siteAddress?.longitude,
        timezone: validatedSiteDetails?.siteAddress?.timezone
      }
      let strObj = JSON.stringify(updatedObj);
      localStorage.setItem("siteAddressDetails", strObj)
      setCreateNewSite(true)
      handleClick(PAGES.AIR_DEVICE_INTEGRATION)
    } else if (validatedSiteDetails?.status?.responseJSON?.errorCode === SITE_VALIDATE_CODES.LAT_LONG_UNABLE || validatedSiteDetails?.status?.responseJSON?.errorCode === SITE_VALIDATE_CODES.TIMEZONE_UNABLE) {
      setShowSiteValidatePopup(true)
      setShowLoader(false)
    } else {
      setShowToast({ status: true, type: 'error', message: I18n.t('mobile.siteSetup.serverError') })
      setShowLoader(false)
    }
  }

  const PopUpSiteSetup = () => {
    return (
      <div className={classes.popUpBox}>
        <div className={classes.popUpHeader}>
          {I18n.t('mobile.siteSetup.invalidAddress')}
        </div>
        <div className={classes.popUpContent}>
          <div className={classes.iconBox}>
            <Icon src="warningOrange" fill={"#6B7073"} />
          </div>
          <div className={classes.popUpMessage}>
            <span>{I18n.t('mobile.siteSetup.addressNotFound')}</span>
            <span>{I18n.t('mobile.siteSetup.contactEnphase')}</span>
          </div>
          <div className={classes.actionBtn} onClick={() => setShowSiteValidatePopup(false)}>
            <span>{I18n.t('mobile.siteSetup.editAddress')}</span>
          </div>
        </div>
      </div>
    )
  }

  const checkDetailsNullity = (obj) => {
    const requiredFields = hasState ? ['siteName', 'address1', 'city', 'state', 'zip', 'country'] : ['siteName', 'address1', 'city', 'zip', 'country']
    return requiredFields.every(key => obj[key]?.trim() !== "")
  }

  const checkForErrorMessages = () => {
    return [errorMessageSiteName.status, errorMessaeaddress1, errorMessaecity, errorMessaestate, errorMessaezip, errorMessagecountry, errorMessagezipFormate].includes("error");
  }

  const isContinueBtnDisabled = (obj) => {
    return !checkDetailsNullity(obj) || checkForErrorMessages();
  }

  const onClickDrawerConfirmBtn = () => {
    if (selectedValue) {
      let updatedZip = reqObj.hasManuallyEntered ? reqObj.zip : '';
      setReqObj({ ...reqObj, state: '', city: reqObj.hasManuallyEntered ? reqObj.city : '', zip: updatedZip, country: selectedValue || reqObj.country });
      setErrorMessagecountry(allCountryCodes.includes(selectedValue) ? 'noerr' : 'error')
      setCountryDrawerOpen(false)
      setSelectedValue(selectedValue)
      updatedZip && isZipCode(updatedZip, selectedValue)
    }
  }

  return (
    <>
      <Header title={I18n.t('mobile.siteSetup.siteSetupDetailsHeader')} onClick={() => handleClick(siteId ? PAGES.CONFIRM_SITE : PAGES.AIR_DEVICES_PROVISION)} />
      <Box className={classes.toastMsg}>
        {showToast.status && <ToastMessage shouldDisplay={showToast.status} content={showToast.message} handleClose={() => setShowToast({ status: false, type: 'alert' })} type={showToast.type} />}
      </Box>
      <>
        <Box className={classes.SiteDetailsContainer}>
          <ProvisionStepper activeStep={0} progressSteps={{step1:0, step2:0, step3:0}} />
          <Box className={classes.heading}>{I18n.t('mobile.siteSetup.siteSetupDetailsHeader')}</Box>
          <Box className={classes.DetailsContainer}>
            <Box className={classes.TrimDetalis}>
              <TextField required label={I18n.t('mobile.siteSetup.siteName')}
                onFocus={() => { setLocationData([]) }}
                value={reqObj.siteName}
                onChange={(e) => { setReqObj({ ...reqObj, siteName: e.target.value }); onTextChange("siteName", e.target.value) }}
                id="siteName"
              />
              {errorMessageSiteName.status == 'error' && (<Typography className={classes.redErrorMessage}>{errorMessageSiteName.msg}</Typography>)}
            </Box>
            <Box className={classes.TrimDetalis}>
              <TextField required label={I18n.t('mobile.siteSetup.streetAddress')}
                defaultValue={reqObj.address1}
                onChange={(e) => { setReqObj({ ...reqObj, address1: e.target.value }); onTextChange("streetAddress1", e.target.value); searchApi(e.target.value) }}
                value={reqObj.address1}
              />
              {errorMessaeaddress1 == 'error' && (<Typography className={classes.redErrorMessage}>{I18n.t('mobile.siteSetup.siteAddressEmptyError')}</Typography>)}
              <Box className={classes.mainlistBox}>
                {locationData?.length !== 0 && locationData?.map((item, index) => (
                  <Box
                    key={index}
                    className={classes.listBox}
                    onClick={() => {
                      setReqObj({ ...reqObj, address1: item.description });
                      setLocationData([]);
                      searchApiwithPlace(item.place_id);
                    }}
                  >
                    {item.description}
                  </Box>
                ))}
              </Box>

            </Box>
            <Box className={classes.TrimDetalis}>
              <TextField label={I18n.t('mobile.siteSetup.streetAddress2')}
                onFocus={(e) => { setLocationData([]) }}
                onChange={(e) => { setReqObj({ ...reqObj, address2: e.target.value }) }}
                value={reqObj.address2}
              />
            </Box>
            <Box className={classes.TrimDetalis}>
              <TextField
                onFocus={(e) => { onFocusTextFieldFunc(e.target.id); setLocationData([]) }}
                id="city_field_site_details"
                required
                label={I18n.t('mobile.siteSetup.city')}
                value={reqObj.city}
                onChange={(e) => { setReqObj({ ...reqObj, city: e.target.value }); onTextChange("cityName", e.target.value) }}
              />
              {errorMessaecity == 'error' && (<Typography className={classes.redErrorMessage}>{I18n.t('mobile.siteSetup.cityNameEmptyError')}</Typography>)}
            </Box>
            {hasState ? <Box className={classes.TrimDetalis}>
              <div className={classes.siteCountryData} onClick={() => { setStateDrawerOpen(true); setSelectedState(reqObj.state); setLocationData([]); }}>
                {reqObj.state ?
                  <div className={classes.siteCountryInput}>
                    <div className={classes.siteCountryInputAfter}>
                      {I18n.t('mobile.siteSetup.stateProvince')}
                      <span className={classes.asteriskStyle}>*</span>
                    </div>
                    <span>{getStateFromStateCode(stateApiData.country_states, reqObj.state)}</span>
                  </div> :
                  <div className={classes.siteCountryInputInit}>
                    {I18n.t('mobile.siteSetup.stateProvince')}
                    <span className={classes.asteriskStyle}>*</span>
                  </div>
                }
                <Icon src="ExpandDrawerIcon" />
              </div>
              <hr className={classes.horizantalRule} style={{ marginTop: reqObj.country ? classes.horizRuleW : classes.horizRuleWo }} />
            </Box> : ''}
            <Box className={classes.TrimDetalis}>
              <TextField
                onFocus={(e) => { onFocusTextFieldFunc(e.target.id); setLocationData([]) }}
                id="zip_code_site_details"
                required
                label={I18n.t('mobile.siteSetup.zipCode')}
                value={reqObj.zip}
                onChange={(e) => { setReqObj({ ...reqObj, zip: e.target.value }); onTextChange("zipCode", e.target.value); isZipCode(e.target.value, reqObj.country); }}
              />
              {errorMessagezipFormate == 'error' && (<Typography className={classes.redErrorMessage}>{I18n.t('mobile.siteSetup.zipCodeEmptyError2')}</Typography>)}
              {errorMessagezipFormate != 'error' && errorMessaezip == 'error' && (<Typography className={classes.redErrorMessage}>{I18n.t('mobile.siteSetup.zipCodeEmptyError')}</Typography>)}
            </Box>
            <div className={classes.siteDetails}>
              <div className={classes.siteCountryData} onClick={() => { setCountryDrawerOpen(true); setLocationData([]); setSelectedValue(reqObj.country) }}>
                {reqObj.country ?
                  <div className={classes.siteCountryInput}>
                    <div className={classes.siteCountryInputAfter}>
                      {I18n.t('mobile.siteSetup.country')}
                      <span className={classes.asteriskStyle}>*</span>
                    </div>
                    <span>{getCountryName(countryApiData, reqObj.country)}</span>
                  </div>
                  :
                  <div className={classes.siteCountryInputInit}>
                    {I18n.t('mobile.siteSetup.country')}
                    <span className={classes.asteriskStyle}>*</span>
                  </div>
                }
                <Icon src="ExpandDrawerIcon" />
              </div>
              <hr className={classes.horizantalRule} style={{ marginTop: reqObj.country ? classes.horizRuleW : classes.horizRuleWo }} />
            </div>
            <Drawer className={classes.drawerBox} label="Country" anchor="bottom" open={countryDrawerOpen} onClose={() => { setCountryDrawerOpen(false) }}>
              <div className={classes.siteCountryDrawerHeader}>
                <span>{I18n.t('mobile.siteSetup.selectCountry')}</span>
                <Button onClick={() => { setCountryDrawerOpen(false); setSelectedValue(reqObj.country) }}><Icon src="close" isDarkMode={isDarkMode} /></Button>
              </div>
              {loading ? <Box className={classes.noDataContainer}>
                <span className={classes.loaderContainer}><Icon src={"loaderV4"} width="80px" height="80px" /></span>
              </Box> :
                isApiFailed ?
                  <Box className={classes.noDataContainer}>
                    <Box className={classes.noCountrySelectedMessage}>{I18n.t('mobile.siteSetup.failedtoShowCountryData')}</Box>
                    <Box onClick={() => getCountryData(userLocale)}><Button className={classes.continueButton}>{I18n.t("mobile.common.tryAgain")}</Button></Box>
                  </Box> :
                  <>
                    <div className={classes.siteCountryRadioBox}>
                      <RadioGroup value={selectedValue || reqObj.country} onChange={(e) => setSelectedValue(e.target.value)}>
                        {Object.keys(allCountryCodes).map(key =>
                          <FormControlLabel value={allCountryCodes[key]} control={<Radio size="small" />} label={getCountryName(countryApiData, allCountryCodes[key])} />
                        )}
                      </RadioGroup>
                    </div>
                    <div className={classes.confirmButtonBox}>
                      <Button variant="contained" type="submit" disabled={selectedValue === reqObj.country || !selectedValue} className={(selectedValue !== reqObj.country && selectedValue) ? classes.siteCountryConfirmBtn : classes.siteCountryDisableBtn}
                        onClick={() => { onClickDrawerConfirmBtn() }}>{I18n.t("mobile.common.confirmBtn")}</Button>
                    </div>
                  </>}
            </Drawer>
            <Drawer className={classes.drawerBox} label="state" anchor="bottom" open={stateDrawerOpen} onClose={() => { setStateDrawerOpen(false); }}>
              <div className={classes.siteCountryDrawerHeader}>
                <span>{I18n.t('mobile.siteSetup.selectState')}</span>
                <Button onClick={() => { setStateDrawerOpen(false); setSelectedState(reqObj.state) }}><Icon src="close" isDarkMode={isDarkMode} /></Button>
              </div>

              {!reqObj.country ?
                <Box className={classes.noCountrySelectedMessage}>{I18n.t('mobile.siteSetup.selectCountryFirst')}</Box> :
                loading ? <Box className={classes.noDataContainer}>
                  <span className={classes.loaderContainer}><Icon src={"loaderV4"} width="80px" height="80px" /></span>
                </Box> :
                  isApiFailed ?
                    <Box className={classes.noDataContainer}>
                      <Box className={classes.noCountrySelectedMessage}>{I18n.t('mobile.siteSetup.failedtoShowStateData')}</Box>
                      <Box onClick={() => getListOfStateName(reqObj.country)}><Button className={classes.continueButton}>{I18n.t("mobile.common.tryAgain")}</Button></Box>
                    </Box> :
                    <>
                      <div className={classes.siteCountryRadioBox}>
                        <RadioGroup value={selectedState || reqObj.state} onChange={(e) => { setSelectedState(e.target.value) }}>
                          {(stateApiData.country_states || []).map((state, index) =>
                            <FormControlLabel key={index}
                              value={state[1]} control={<Radio size="small" />} label={getStateName(stateApiData.country_states, state[0])} />
                          )}
                        </RadioGroup>
                      </div>
                      <div className={classes.confirmButtonBox}>
                        <Button variant="contained" type="submit" disabled={selectedState === reqObj.state || !selectedState} className={(selectedState !== reqObj.state && selectedState) ? classes.siteCountryConfirmBtn : classes.siteCountryDisableBtn} onClick={() => handleStateConfirmBtn()}>
                          {I18n.t("mobile.common.confirmBtn")}
                        </Button>
                      </div>
                    </>}
            </Drawer>
          </Box>
          <Box className={classes.AddSiteButton}>
            {showLoader ? <Box className={classes.loaderBtn}>
              <Icon src={"loaderV4"} width="40px" height="40px" />
            </Box> :
              <Button
                variant={"text"}
                className={!isContinueBtnDisabled(reqObj) ? classes.continueButton : classes.disableContinueButton}
                disabled={isContinueBtnDisabled(reqObj)}
                onClick={() => { !isContinueBtnDisabled(reqObj) && addSiteDevice() }}
              >
                {I18n.t("mobile.siteSetup.continue")}
              </Button>}
          </Box>
        </Box>
      </>
      {<PopUp
        open={showSiteValidatePopup}
        handleClose={() => setShowSiteValidatePopup(false)}
        content={<PopUpSiteSetup />}
      />}

    </>

  );
};

export default SiteDetails;

